import apiClient from './apiClient';
import { cleanParams } from '@/utils/buildQuery';

const base = '/admin/users';

export const usersService = {
  list: (params) => apiClient.get(base, { params: cleanParams(params) }),
  get: (id) => apiClient.get(`${base}/${id}`),
  create: (payload) => apiClient.post(base, payload),
  update: (id, payload) => apiClient.patch(`${base}/${id}`, payload),
  remove: (id) => apiClient.delete(`${base}/${id}`),
  block: (id, reason) => apiClient.post(`${base}/${id}/block`, { reason }),
  unblock: (id) => apiClient.post(`${base}/${id}/unblock`),
  grantPro: (id, payload) => apiClient.post(`${base}/${id}/grant-pro`, payload),
  revokePro: (id) => apiClient.post(`${base}/${id}/revoke-pro`),
  forceLogout: (id) => apiClient.post(`${base}/${id}/force-logout`),
  bulk: (ids, action, payload = {}) => apiClient.post(`${base}/bulk`, { ids, action, payload }),
  activity: (id, params) => apiClient.get(`${base}/${id}/activity`, { params: cleanParams(params) }),
};

export default usersService;
